import React, { useEffect } from "react";
import { Box, Stack, TextField, Typography } from "@mui/material";
import ReactApexChart from "react-apexcharts";
import { useQuery } from "@apollo/client";
import { useState } from "react";
import { GET_DIALY_INCOME_CHART } from "../../Schema/Dashboard";
import { currencyFormat } from "../../Function/DynamicFn";
import { useNavigate } from "react-router-dom";

//Date
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from "moment";
import { SelectAcademicYear } from "../Include/DynamicSelect";
import LoadingPage from "../Include/LoadingPage";

export default function DialyIncomeChart({ academicYearId }) {


  const navigate = useNavigate();
  const [label, setLabel] = useState()
  const [value, setValue] = useState()

  const [loading, setLoading] = useState(true)

  const { refetch } = useQuery(GET_DIALY_INCOME_CHART, {
    variables: {
      academicYearId: academicYearId ?? "",
    },
    onCompleted: ({ getDailyIncomeChart }) => {
      // console.log("getDailyIncomeChart", getDailyIncomeChart);
      setLoading(false)
      if (getDailyIncomeChart) {
        setLabel(getDailyIncomeChart?.map((e) => e?.label));
        setValue(getDailyIncomeChart?.map((e) => e?.value));
      }
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  useEffect(() => {
    refetch();
  }, [academicYearId]);

  const state = {
    options: {
      chart: {
        type: "bar",
        height: 350,
        fontFamily: "Khmer OS Siemreap",
        stacked: false,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "50%",
          endingShape: "rounded",
          dataLabels: {
            position: "top", // top, center, bottom
          },
        },
      },
      dataLabels: {
        enabled: true,
        offsetY: -25,
        style: {
          fontSize: "12px",
          colors: ["#304758"],
        },
        formatter: function (val, opts) {
          if (val > 0) {
            return `$ ${currencyFormat(val)}`;
          } else {
            return "0";
          }
        },
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories: label,
      },
      yaxis: {
        // max: maxSeriesData + 5,
        labels: {
          style: {
            fontFamily: "Siemreap",
          },
        },
      },
      tooltip: {
        y: {
          formatter: function (val) {
            if (val > 0) {
              return val;
            } else {
              return 0;
            }
          },
        },
      },
      fill: {
        opacity: 1,
      },
    },
    series: [
      {
        name: "Amount",
        data: value,
        color: "#0071F1",
      },
    ],
  };

  return (
    <>
      <Box
        className="employee-chart"
        sx={{ cursor: "pointer" }}
        onClick={() => navigate("/report/income-report")}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems={"center"}
        >
          <Typography className="chart-title" sx={{ color: "#0f81c2" }}>
            Dialy Income in {moment()?.format("MMMM")}
          </Typography>
        </Stack>
        {
          loading ?
            <LoadingPage /> :
            <div id="chart">
              <ReactApexChart
                options={state.options}
                series={state.series}
                type="bar"
                height={330}
              />
            </div>
        }
      </Box>
    </>
  );
}
